import React from "react";

import tizen from "../../../resources/tizen.png";

import type { JSX } from "react";

interface ITizenIcon {
  className?: string;
}

function TizenIcon(props: ITizenIcon): JSX.Element {
  const { className } = props;
  return <img alt="tizen-icon" className={className} src={tizen} />;
}

export default TizenIcon;
